import React, { useState, useRef, useEffect } from 'react'
import { Input } from 'components/ui'

const OTPInput = ({ value, onChange, onComplete, error, ...props }) => {
  const [otp, setOtp] = useState(['', '', '', '', ''])
  const inputRefs = useRef([])

  useEffect(() => {
    if (value) {
      const otpArray = value.split('').slice(0, 5)
      const newOtp = [...otpArray]
      while (newOtp.length < 5) {
        newOtp.push('')
      }
      setOtp(newOtp)
    }
  }, [value])

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return // Only allow digits

    const newOtp = [...otp]
    newOtp[index] = value
    setOtp(newOtp)

    const otpString = newOtp.join('')
    onChange(otpString)

    // Auto-focus next input
    if (value && index < 4) {
      inputRefs.current[index + 1]?.focus()
    }

    // Call onComplete when all fields are filled
    if (otpString.length === 5) {
      onComplete(otpString)
    }
  }

  const handleKeyDown = (index, e) => {
    // Handle backspace
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus()
    }
  }

  const handlePaste = (e) => {
    e.preventDefault()
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 5)
    const newOtp = pastedData.split('')
    while (newOtp.length < 5) {
      newOtp.push('')
    }
    setOtp(newOtp)
    onChange(newOtp.join(''))
    
    if (newOtp.join('').length === 5) {
      onComplete(newOtp.join(''))
    }
  }

  return (
    <div className="flex gap-2 justify-center">
      {otp.map((digit, index) => (
        <Input
          key={index}
          ref={(el) => (inputRefs.current[index] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          className={`w-12 h-12 text-center text-lg font-semibold ${
            error ? 'border-red-500' : 'border-gray-300'
          }`}
          style={{
            textAlign: 'center',
            fontSize: '18px',
            fontWeight: '600',
            border: error ? '2px solid #ef4444' : '2px solid #d1d5db',
            borderRadius: '8px',
            backgroundColor: '#ffffff'
          }}
          {...props}
        />
      ))}
    </div>
  )
}

export default OTPInput
